// Huntrix member configuration
import { GroupConfig, HuntrixMember, CostumeId } from '../types';

export const HUNTRIX_MEMBERS: Record<string, Omit<HuntrixMember, 'spirit' | 'costume'>> = {
    'RUMI': { id: 'RUMI', name: 'Rumi', role: 'LEADER', maxSpirit: 100, vocal: 25, dance: 15, style: 20, price: 0 },
    'MIRA': { id: 'MIRA', name: 'Mira', role: 'DANCER', maxSpirit: 100, vocal: 12, dance: 35, style: 25, price: 0 },
    'ZOEY': { id: 'ZOEY', name: 'Zoey', role: 'RAPPER', maxSpirit: 100, vocal: 18, dance: 22, style: 15, price: 0 },
};

const initialMembers = [
    { ...HUNTRIX_MEMBERS.ZOEY, spirit: 100, costume: 'DEFAULT' as CostumeId },
    { ...HUNTRIX_MEMBERS.RUMI, spirit: 100, costume: 'DEFAULT' as CostumeId },
    { ...HUNTRIX_MEMBERS.MIRA, spirit: 100, costume: 'DEFAULT' as CostumeId },
];

export const INITIAL_HUNTRIX_CONFIG: GroupConfig = {
    name: 'HUNTR/X',
    members: initialMembers,
};
